import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { useT } from "contexts/TranslationContext"; // import hook
import SelectLocale from "helpers/SelectLocale";
import useAuth from 'hooks/useAuth';

export default function Header() {
  const { isLoggedIn } = useAuth();
  const t = useT(); // use the translation function
  return (
    <AppBar position="static" color="transparent" elevation={0}>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography variant="h6" fontWeight="bold" mt={2}>
          Chronotrack
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }} mt={2}>
          <SelectLocale />
          <Button href="#features">{t("app.features")}</Button>
          <Button href="#pricing">{t("app.pricing")}</Button>
          <Button href="#contact">{t("app.contact")}</Button>
          {isLoggedIn ?
          (
            <Button href="dashboard">{t("app.dashboard")}</Button>
          ) :
          (
            <Button href="register">{t("app.signup")}</Button>

          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
